import SantaHat from './SantaHat';
import { IS_CHRISTMAS_SEASON } from '../season';

export default function LogoWithHat({
  children,
  hatWidth = '55%',
  top = '-22%',
  left = '-12%',
  rotate = -14,
  color,
}) {
  return (
    <span style={{ position: 'relative', display: 'inline-block', lineHeight: 0 }}>
      {children}
      {IS_CHRISTMAS_SEASON && (
        <SantaHat
          color={color}
          style={{
            position: 'absolute',
            top,
            left,
            width: hatWidth,
            transform: `rotate(${rotate}deg)`,
            pointerEvents: 'none',
            filter: 'drop-shadow(0 2px 3px rgba(0,0,0,0.3))',
          }}
        />
      )}
    </span>
  );
}